import { render, staticRenderFns } from "./StatsGlobalAdvance.vue?vue&type=template&id=b1d43b0e&"
import script from "./StatsGlobalAdvance.vue?vue&type=script&lang=js&"
export * from "./StatsGlobalAdvance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports